// extracted by mini-css-extract-plugin
export default {"container":"qbHYy","dot":"TLoOP","opacitychange":"At-b0"};